//deps
import React, { memo, ReactElement, useMemo } from "react";

//constants
import { LOGIN_WIDGET_DATA, PRIVACY_POLICY_URI } from "@cart-ui/constants/TextDict";
import { CART_FOOTER_TEST_IDS } from "@swiggy-private/cart-test-ids";

//styles
import { Container, SubTitleText, ActionsSection, ActionButton, InfoContainer } from "../styled";

// components
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { GenericIcon } from "@swiggy-private/dls-web-icons/dist/GenericIconWeb";
import { default as InfoFilledIcon } from "@swiggy-private/dls-web-icons/dist/web/generic/infoFilled/12";

//types and interfaces
export interface LoginWidgetProps {
    onLogin: VoidFunction;
    isJioHotstarFlow?: boolean;
    isIxigoFlow?: boolean;
    isQuickCheckout?: boolean;
}

const getUnderLinedtext = (text: string) => {
    return text
        .replace("[[", `<a href="${PRIVACY_POLICY_URI}" style="text-decoration: underline;">`)
        .replace("]]", "</a>");
};

function LoginWidget(props: LoginWidgetProps): ReactElement {
    const title = useMemo(() => {
        if (props.isJioHotstarFlow) {
            return LOGIN_WIDGET_DATA.JHS_SUB_TITLE;
        }
        return LOGIN_WIDGET_DATA.TITLE;
    }, [props.isJioHotstarFlow]);

    const cta = useMemo(() => {
        if (props.isIxigoFlow) {
            return LOGIN_WIDGET_DATA.EXTERNAL_LOGIN_CTA;
        }
        if (props.isJioHotstarFlow) {
            return LOGIN_WIDGET_DATA.JHS_CTA_TEXT;
        }
        return LOGIN_WIDGET_DATA.CTA;
    }, [props.isIxigoFlow, props.isJioHotstarFlow]);

    const subTitle = useMemo(() => {
        if (props.isIxigoFlow) {
            return LOGIN_WIDGET_DATA.EXTERNAL_LOGIN_SUB_TITLE;
        }
        return LOGIN_WIDGET_DATA.SUB_TITLE;
    }, [props.isIxigoFlow]);

    return (
        <Container isJioHotstarFlow={props.isJioHotstarFlow}>
            <div>
                <Text
                    variant={props.isJioHotstarFlow ? "V2.body1.neutral.bold" : "V2.subheading1.neutral.black"}
                    color="text_High_Emphasis"
                >
                    {title}
                </Text>
                {!props.isJioHotstarFlow && (
                    <SubTitleText
                        variant={"V2.body3.neutral.regular"}
                        color={"text_Med_Emphasis"}
                        isQuickCheckout={props.isQuickCheckout}
                    >
                        {subTitle}
                    </SubTitleText>
                )}
            </div>
            <ActionsSection isJioHotstarFlow={props.isJioHotstarFlow}>
                <ActionButton
                    variant="fullwidth"
                    buttonType="primary"
                    buttonSize={props.isJioHotstarFlow ? "medium" : "large"}
                    onClick={props.onLogin}
                    data-testid={CART_FOOTER_TEST_IDS.LOGIN_TO_CONTINUE}
                >
                    {cta}
                </ActionButton>
            </ActionsSection>
            {props.isJioHotstarFlow && (
                <InfoContainer>
                    <GenericIcon Icon={InfoFilledIcon} fillColor="text_Low_Emphasis" />
                    <Text
                        variant="V2.caption.neutral.medium"
                        color="text_Low_Emphasis"
                        dangerouslySetInnerHTML={{ __html: getUnderLinedtext(LOGIN_WIDGET_DATA.JHS_INFO_TEXT) }}
                    />
                </InfoContainer>
            )}
        </Container>
    );
}

export default memo(LoginWidget);
